export type FailureReasonTypes =
  | 'FaceSpoofing.Detected'
  | 'FacesMismatch.Detected'
  | 'Luminance.TooLow'
  | 'Liveness.NotDetected'
  | 'Document.Illegible'
  | 'Document.NotLegible'
  | 'Document.NotSecurityElements'
  | 'Document.Expired'
  | 'Document.Aspect'
  | 'User.CorroborationFailed'
  | 'default'

export const FAILURE_REASONS: FailureReasonTypes[] = [
  'FaceSpoofing.Detected',
  'FacesMismatch.Detected',
  'Luminance.TooLow',
  'Liveness.NotDetected',
  'Document.Illegible',
  'Document.NotLegible',
  'Document.NotSecurityElements',
  'Document.Expired',
  'Document.Aspect',
  'User.CorroborationFailed',
  'default',
] as const

// `error` query value used by the backend when a Tink AccountInformation
// (AIS) transaction fails; it has no `errorReason` of its own.
export const ACCOUNT_INFORMATION_FAILURE_ERROR = 'account_information_failure'

// GoCardless AIS failure reason: the bank returned nothing but the account holder
// name, and the tenant requires more (attempt-api `failWhenOnlyHolderNamePresent`).
export const ACCOUNT_INFORMATION_INSUFFICIENT_DATA_REASON =
  'AccountInformation.InsufficientAccountData'

// Copy keys of the Enpal failure screen: the shared failure reasons plus the
// AIS failure, which only that screen (and its translations) knows about.
export type VerifiedErrorReasonTypes = FailureReasonTypes | 'AccountInformation.Failed'

// Resolves the failure-screen copy key from the redirect query params. A known
// `errorReason` wins; otherwise an AIS failure gets its own copy and anything
// else falls back to the default screen.
export const getVerifiedErrorReason = (
  error: string | null,
  errorReason: string | null
): VerifiedErrorReasonTypes => {
  if (errorReason && FAILURE_REASONS.includes(errorReason as FailureReasonTypes)) {
    return errorReason as FailureReasonTypes
  }

  return error === ACCOUNT_INFORMATION_FAILURE_ERROR ? 'AccountInformation.Failed' : 'default'
}

export interface GetFailureDetailstResponse {
  allowRetryFromFailureScreen?: boolean
  providers: {
    eidv?: {
      rejectionReason: string
    }
    signature?: {
      failureReason: FailureReasonTypes
    }
    corroboration?: {
      rejectionReasons: string[]
      firstName?: {
        expected: string
        actual: string
      }
      lastName?: {
        expected: string
        actual: string
      }
    }
  }
}

export interface ResumeFromFailureScreenResponse {
  resumeUrl: string
}

export interface ErrorTrans {
  title: string
  description: string
  tryAgain: string
  beforeYouRetry?: string
  step1?: string
  step2?: string
  step3?: string
  step4?: string
  yourName?: string
  didNotMatch?: string
}

export interface GetFailureDetailstResponse {
  awaitingResumption?: boolean
}
